import { render, staticRenderFns } from "./Lgx02668426028919138812513.vue?vue&type=template&id=0241801e&scoped=true&"
import script from "./Lgx02668426028919138812513.vue?vue&type=script&lang=js&"
export * from "./Lgx02668426028919138812513.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02668426028919138812513.vue?vue&type=style&index=0&id=0241801e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241801e",
  null
  
)

export default component.exports